import { useMemo } from 'react';
import { LegalPageLayout } from '../components/legal-page-layout';
import { MarkdownRenderer } from '@/components/ui/markdown-renderer';
import { dataProcessingContent } from '../data/data-processing-content';
import { extractHeadings } from '../utils/extract-headings';

export function DataProcessingPage() {
  const headings = useMemo(() => extractHeadings(dataProcessingContent), []);

  return (
    <LegalPageLayout
      title="Acuerdo de Procesamiento de Datos"
      lastUpdated="Marzo 2026"
      headings={headings}
    >
      <MarkdownRenderer content={dataProcessingContent} />
    </LegalPageLayout>
  );
}
